import Header from "./components/Header";
import Hero from "./components/Hero";
import Work from "./components/Work";
import Testimonials from "./components/Testimonials";
import ServicesSection from "./components/ServicesSection";
import Worktogether from "./components/Worktogether";
import Footer from "./components/Footer";
import Slide from "./components/Slide";
import './index.css';


function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Work />
      <Slide />
      <ServicesSection />
      <Worktogether />
      <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
